import React from 'react';

import {useRemoveTeamItem, useTeams} from 'app/teams/api';
import {convertLocationParamsToFetchParams} from 'app/teams/utils';
import {useInviteUser} from 'app/user/api';

import {AddToTeamPopover} from './AddToTeamPopover';
import {UserAttachedItem} from './UserAttachedItem';

import type {OverlayProps} from 'app/general/overlays';
import type {UserSerializedType} from 'sweet-types';

interface Props {
  overlayProps: OverlayProps;
  user: UserSerializedType;
}

export const AddUserToTeamPopover = ({overlayProps, user}: Props) => {
  const {data: attached} = useTeams(
    convertLocationParamsToFetchParams({
      user_id: user.id.toString(),
    }),
    {refetchOnMountOrArgChange: false}
  );

  const [inviteUser] = useInviteUser();
  const [deleteMembership] = useRemoveTeamItem();

  return (
    <AddToTeamPopover
      overlayProps={overlayProps}
      attached={attached?.results}
      itemURL={user.url}
      onSuccess={() => Promise.resolve(undefined)}
      AttachedItemComponent={UserAttachedItem}
      attachedItemComponentProps={{user}}
      addItemToTeam={(team, url) =>
        inviteUser({
          invitations: [
            {
              send_mail: false,
              content_type: 'team',
              object_id: team.id,
              to_user_id: url,
              permission: 'view',
            },
          ],
        }).unwrap()
      }
      removeItemsFromTeam={(team) =>
        deleteMembership({
          teamURL: team.url,
          item: user,
        }).unwrap()
      }
    />
  );
};
